import { render, staticRenderFns } from "./assistList.vue?vue&type=template&id=14ac2634"
import script from "./assistList.vue?vue&type=script&lang=js"
export * from "./assistList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports